import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { get } from 'lodash-es';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { CmsEntities, bindToContent } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { CPO_NEWS_WIDGET_CONTENT_PATH } from 'client/site-modules/shared/constants/editorial/editorial';
import { Link } from 'site-modules/shared/components/link/link';
import { getTitleWithNoOrphans } from 'site-modules/shared/utils/get-title-with-no-orphans';
import {
  CARDS_TYPE_MAP,
  CarNewsArticlesGrid,
  // eslint-disable-next-line venom/no-internal-modules
} from 'site-modules/editorial/components/car-news/car-news-articles-grid/car-news-articles-grid';

const FORCE_LAYOUT = {
  true: [[CARDS_TYPE_MAP.inline]],
};

export function NewsWidgetUI({ newsContent = DEFAULT_CONTENT, className = null, isMobile = false }) {
  if (!newsContent.title) {
    return null;
  }
  const title = getTitleWithNoOrphans(newsContent.title);

  return (
    <section className={classnames('news-widget', className)} data-tracking-parent="edm-entry-news-widget">
      <Link to="/car-news/">
        <h2 className="text-capitalize heading-3 mb-1_5">{title}</h2>
      </Link>
      <CarNewsArticlesGrid
        content={newsContent}
        isMobile={isMobile}
        totalCardsLimit={7}
        forceLayout={FORCE_LAYOUT[isMobile]}
      />
    </section>
  );
}

NewsWidgetUI.propTypes = {
  newsContent: CmsEntities.Content,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
};

const mapStateToProps = state => ({
  isMobile: get(state, 'mobile'),
});

export const NewsWidget = connect(mapStateToProps)(
  connectToModel(NewsWidgetUI, {
    newsContent: bindToContent(CPO_NEWS_WIDGET_CONTENT_PATH, 'cpo-widget-sponsored'),
  })
);
